<template>
  <div>
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>
          <div style="display:table;">
            <div style="display:table-cell;vertical-align: middle;">
              <img
                width="50px"
                src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/メスガキ.png"
                style="border-radius: 25px;"
              >
            </div>
            <div style="display:table-cell;vertical-align: middle;">
              <span>マスターデュエル カード管理 Ver1.0</span>
            </div>
          </div>
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>

        <!-- <v-btn class="primary" @click="dataSearch()">データ取得</v-btn> -->
        <v-spacer></v-spacer>
      </v-toolbar>
    </div>

    <v-card class="ma-4 pa-2 text-right">
      <v-btn color="primary" dark class="mb-2" @click="editItem()">
        <v-icon>mdi-new-box</v-icon>カード新規追加
      </v-btn>
      <v-btn
        color="red darken-4"
        dark
        class="mb-2"
        @click="cardIdFilePut()"
        style="margin-left:20px;"
      >
        <v-icon>mdi-tray-arrow-up</v-icon>本番データ反映
      </v-btn>
    </v-card>

    <v-card class="ma-6"></v-card>
    <v-card class="ma-6" style="min-height: 2203px;">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        id="data_search"
        class="mx-4 pa-4"
        placeholder="検索"
        clearable
      ></v-text-field>

      <v-data-iterator
        :headers="headers"
        :items="list"
        :search="search"
        :custom-filter="customFilter"
        :items-per-page="100"
        :footer-props="{ itemsPerPageOptions: [100, 200, 500] }"
      >
        <template v-slot:default="props">
          <ul class="deck_list">
            <li v-for="item in props.items" :key="item.title" color style="border-radius:10px;">
              <v-hover v-slot="{ hover }" open-delay="0">
                <v-card
                  @click="editItem(item)"
                  style="margin-bottom: 10px; padding-top: 5px;"
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="blue lighten-4 ma-1"
                >
                  <div
                    style="position: relative; width:60px!important; margin-left: auto; margin-right: auto;"
                  >
                    <img
                      width="60"
                      :src="'https://admin.appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/'+item.id+'.webp'"
                    >
                    <img
                      v-if="item.limit_type == '禁止'"
                      loading="lazy"
                      src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/kinshi.png"
                      width="20px"
                      height="20px"
                      style="position: absolute; top:0px; left:0px; background-color: #222; border-radius: 30px;"
                    >
                    <div v-if="item.limit_type == '準制限'" class="limit">2</div>
                    <div v-if="item.limit_type == '制限'" class="limit">1</div>
                  </div>

                  <div @click="editItem(item)" class="anime_title mt-2">{{ item.name }}</div>
                  <div>
                    <v-icon
                      color="light-blue darken-4"
                      large
                      @click="copyToClipboard(item, 'img')"
                    >mdi-image-outline</v-icon>
                    <v-icon
                      color="light-blue darken-4"
                      large
                      @click="copyToClipboard(item, '')"
                    >mdi-image-off</v-icon>
                  </div>
                </v-card>
              </v-hover>
              <div @click="editItem(item)"></div>
            </li>
          </ul>
        </template>
      </v-data-iterator>
    </v-card>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog v-model="showDialog" scrollable persistent max-width="1500px">
        <v-card width="800" :disabled="loading">
          <v-overlay :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-4 ml-1" style="width:100%">
              <v-col cols="10" style="display:table;">
                <div
                  style="display:table-cell; vertical-align:middle; text-align:left; width: 40px;"
                >
                  <a
                    :href="'https://admin.appmedia.jp/master_duel/'+target_url"
                    target="_blank"
                    v-if="target_id != ''"
                  >
                    <img
                      width="40"
                      :src="'https://admin.appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/'+target_id+'.webp'"
                    >
                  </a>
                  <img
                    width="40"
                    src="https://admin.appmedia.jp/wp-content/themes/appmedia/lib/yugioh/img/all_cards/no_image.webp"
                    v-else
                  >
                </div>
                <div
                  style="display:table-cell; vertical-align:middle; text-align:left;"
                  v-if="target_id != ''"
                >
                  《
                  <a :href="target_url" target="_blank">{{ target_name }}</a>》を編集中
                </div>
                <div
                  style="display:table-cell; vertical-align:middle; text-align:left;"
                  v-else
                >カードを新規追加</div>
              </v-col>
              <v-col cols="2" class="text-right">
                <v-btn color="blue darken-1" text @click="closeDialog()" style="font-size:40px;">×</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <div class="contents">
              <v-row>
                <v-col cols="7">
                  <v-tabs center-active v-model="tab" class="pt-0">
                    <v-tab>基本情報</v-tab>
                    <v-tab>テーマ、効果</v-tab>
                    <v-tab>入手方法、評価</v-tab>
                  </v-tabs>
                </v-col>
              </v-row>
              <v-tabs-items v-model="tab" class="pt-0">
                <v-tab-item style="min-height:500px;">
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="カードID"
                        hide-details="auto"
                        class="pa-0"
                        :rules="rules"
                        v-model="target_id"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="個別記事URL"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_url"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="カード名"
                        hide-details="auto"
                        class="pa-0"
                        :rules="rules"
                        v-model="target_name"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="カード名(かな)"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_name_kana"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="カード名(英語)"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_name_eng"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-select
                        label="レアリティ"
                        class="pa-0"
                        :items="rarities"
                        v-model="target_rarity"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="属性、魔法/罠"
                        class="pa-0"
                        :items="attrs"
                        v-model="target_attr"
                        transition="scroll-y-reverse-transition"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select label="種族" class="pa-0" :items="races" v-model="target_race"></v-select>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="レベル"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_level"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-select
                        label="リンクマーカー"
                        class="pa-0"
                        :items="links"
                        v-model="target_link_marker"
                        multiple
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-select
                        label="モンスタータイプ1"
                        class="pa-0"
                        :items="mon1"
                        v-model="target_monster_type_1"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="モンスタータイプ2"
                        class="pa-0"
                        :items="mon2"
                        v-model="target_monster_type_2"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="モンスタータイプ3"
                        class="pa-0"
                        :items="mon3"
                        v-model="target_monster_type_3"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="魔法カードタイプ"
                        class="pa-0"
                        :items="mag"
                        v-model="target_magic_card_type"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        label="罠カードタイプ"
                        class="pa-0"
                        :items="tra"
                        v-model="target_trap_card_type"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-text-field
                        label="攻撃力"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_offensive"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="守備力"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_defensive"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="リミットレギュレーション(通常)"
                        hide-details="auto"
                        class="pa-0"
                        v-model="target_limit_type"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item style="min-height:500px;">
                  <v-row class="pr-4 pl-4 ma-1" style="width:100%">
                    <v-col>
                      <v-autocomplete
                        v-model="target_theme"
                        :items="theme_list"
                        outlined
                        dense
                        chips
                        small-chips
                        label="テーマ"
                        multiple
                        class="pt-0 pb-0"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-textarea
                        rows="5"
                        class="custom_textarea pt-0"
                        auto-grow
                        outlined
                        v-model="target_card_text"
                        label="カードテキスト"
                        counter="500"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-textarea
                        rows="5"
                        class="custom_textarea pt-0"
                        auto-grow
                        outlined
                        v-model="target_pendulum"
                        label="ペンデュラム効果"
                        counter="500"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item style="min-height:500px;">
                  <v-row class="pr-4 pl-4 ma-1" style="width:100%">
                    <v-col>
                      <v-autocomplete
                        v-model="target_get_way_1"
                        :items="event_list"
                        outlined
                        dense
                        chips
                        small-chips
                        label="入手方法1(イベント)"
                        multiple
                        class="pt-0 pb-0"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ma-1" style="width:100%">
                    <v-col>
                      <v-autocomplete
                        v-model="target_get_way_2"
                        :items="pack_list"
                        outlined
                        dense
                        chips
                        small-chips
                        label="入手方法2(パック)"
                        multiple
                        class="pt-0 pb-0"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="pr-4 pl-4 ml-1" style="width:100%">
                    <v-col>
                      <v-textarea
                        rows="5"
                        class="custom_textarea pt-0 pb-0"
                        auto-grow
                        outlined
                        v-model="target_card_evaluation"
                        label="評価"
                        counter="2000"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="closeDialog()">閉じる</v-btn>
            <v-row class="pa-4 ml-1" align="center" style>
              <v-col style="max-width:120px;text-align:right;">
                <v-btn color="blue" dark @click="saveItem()">更新</v-btn>
              </v-col>
              <v-col cols="12" style="max-width:120px;text-align:right;">
                <v-btn color="red" dark @click="delItem()">削除</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";
// ドラッグアンドドロップ
// import draggable from "vuedraggable";

export default {
  components: {
    // draggable
  },

  data() {
    return {
      detail_dialog: false,

      detail_cards_list: [],

      dialog: false,
      confirm_dialog: false,
      overlay: false,

      honban_flg: false,

      showDialog: false,

      loading: false,

      tab: null,

      list: [],
      list2: [],

      theme_list: [],

      pack_list: [],

      event_list: [],

      rarities: ["UR", "SR", "R", "N", "未実装"],

      mon1: ["通常", "効果"],

      mon2: [
        "融合",
        "儀式",
        "シンクロ",
        "エクシーズ",
        "ペンデュラム",
        "融合ペンデュラム",
        "儀式ペンデュラム",
        "シンクロペンデュラム",
        "エクシーズペンデュラム",
        "リンク"
      ],

      mon3: [
        "リバース",
        "特殊召喚",
        "トゥーン",
        "スピリット",
        "ユニオン",
        "デュアル",
        "チューナー"
      ],

      mag: ["通常", "フィールド", "速攻", "儀式", "永続", "装備"],

      tra: ["通常", "永続", "カウンター"],

      links: ["上", "右上", "右", "右下", "下", "左下", "左", "左上"],

      attrs: [
        "闇属性",
        "光属性",
        "地属性",
        "水属性",
        "炎属性",
        "風属性",
        "神属性",
        "魔法",
        "罠"
      ],

      races: [
        "魔法使い族",
        "ドラゴン族",
        "アンデット族",
        "戦士族",
        "獣戦士族",
        "獣族",
        "鳥獣族",
        "悪魔族",
        "天使族",
        "水族",
        "炎族",
        "雷族",
        "岩石族",
        "植物族",
        "機械族",
        "サイキック族",
        "幻神獣族",
        "創造神族",
        "幻竜族",
        "サイバース族"
      ],

      target_id: "",
      target_name: "",
      target_name_kana: "",
      target_name_eng: "",
      target_attr: "",
      target_race: "",
      target_level: 0,
      target_offensive: 0,
      target_defensive: 0,
      target_monster_type_1: "",
      target_monster_type_2: "",
      target_monster_type_3: "",
      target_magic_card_type: "",
      target_trap_card_type: "",
      target_card_text: "",
      target_scale: "",
      target_pendulum: "",
      target_link_marker: [],
      target_theme: "",
      target_rarity: "",
      target_card_evaluation: "",
      target_get_way_1: [],
      target_get_way_2: [],
      target_url: "",
      target_limit_type: "",
      target_last_update: "",
      target_last_upload: "",
      target_release_date: "",

      headers: [],

      rules: [value => !!value || "入力必須"],

      // //検索用パラメータ
      search: "",

      // // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {},

  //---------------------------
  // 読み込み時に実行
  //---------------------------
  created: function() {
    // カード一覧
    this.getCardList();
    // テーマ一覧
    this.getThemeList();
    // パック一覧
    this.getPackList();
    // イベントリスト
    this.getEventList();
  },

  methods: {
    customFilter: function(items, search) {
      if (search === null || search == "") {
        return items;
      }
      items = items.filter(function(value) {
        if (value.name.indexOf(search) != -1) {
          return true;
        } else if (value.name_kana.indexOf(search) != -1) {
          return true;
        } else if (value.name.indexOf(search) != -1) {
          return true;
        } else {
          return false;
        }
      });
      return items;
    },

    //---------------------------
    // カードリスト取得_カード名とIDのみ
    //---------------------------
    getCardList() {
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/yugiho_search?get_type=実装,カード生成のみ入手可,入手不可,未実装&all_flg=true"
        )
        .then(response => {
          //   console.log(response);
          // // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);

          values.forEach(value => {
            items.push(value);
          });
          this.list = items;
        });
    },

    //---------------------------
    // テーマリスト取得
    //---------------------------
    getThemeList() {
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/cross_duel_list?table_name=yugioh_MD_theme"
        )
        .then(response => {
          // console.log(response);
          // // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);
          values.forEach(value => {
            items.push(value.name);
          });
          this.theme_list = items;
        });
      // console.log(this.skill_list);
    },

    //---------------------------
    // パックリスト取得
    //---------------------------
    getPackList() {
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/cross_duel_list?table_name=yugioh_MD_pack"
        )
        .then(response => {
          // console.log(response);
          // // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);
          values.forEach(value => {
            if (value.pack_type != "現実") {
              items.push(value.name);
            }
          });
          this.pack_list = items;
        });
      // console.log(this.skill_list);
    },

    //---------------------------
    // イベントリスト取得
    //---------------------------
    getEventList() {
      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/cross_duel_list?table_name=yugioh_MD_event"
        )
        .then(response => {
          // console.log(response);
          // // v-data-tableを使うときは配列に格納する
          const items = [];
          const values = Object.values(response.data);
          values.forEach(value => {
            items.push(value.name);
          });
          this.event_list = items;
        });
      // console.log(this.skill_list);
    },

    //---------------------------
    // カード一覧表示
    //---------------------------
    cardList(name) {
      this.card_list = this.detail_cards_list[name];
    },

    //---------------------------
    // 編集画面
    //---------------------------
    editItem(item) {
      if ((item === void 0) === false) {
        // this.getCardList2(item.id);

        this.target_id = item.id;
        this.target_name = item.name;
        this.target_name_kana = item.name_kana;
        this.target_name_eng = item.name_eng;
        this.target_attr = item.attr;
        this.target_race = item.race;
        this.target_level = item.level;
        this.target_offensive = item.offensive;
        this.target_defensive = item.defensive;
        this.target_monster_type_1 = item.monster_type_1;
        this.target_monster_type_2 = item.monster_type_2;
        this.target_monster_type_3 = item.monster_type_3;
        this.target_magic_card_type = item.magic_card_type;
        this.target_trap_card_type = item.trap_card_type;
        this.target_card_text = item.card_text;
        this.target_scale = item.scale;
        this.target_pendulum = item.pendulum;
        if (item.link_marker != "") {
          this.target_link_marker = item.link_marker.split("&");
        }
        this.target_theme = item.theme;
        this.target_rarity = item.rarity;
        this.target_card_evaluation = item.card_evaluation;
        if (item.get_way_1 != "") {
          this.target_get_way_1 = item.get_way_1.split("&");
        }
        if (item.get_way_2 != "") {
          this.target_get_way_2 = item.get_way_2.split("&");
        }
        this.target_url = item.url;
        this.target_limit_type = item.limit_type;
        this.target_last_update = item.last_update;
        this.target_last_upload = item.last_upload;
        this.target_release_date = item.release_date;

        this.target_post_type = "update";
      } else {
        this.target_id = "";
        this.target_name = "";
        this.target_name_kana = "";
        this.target_name_eng = "";
        this.target_attr = "";
        this.target_race = "";
        this.target_level = "";
        this.target_offensive = "";
        this.target_defensive = "";
        this.target_monster_type_1 = "";
        this.target_monster_type_2 = "";
        this.target_monster_type_3 = "";
        this.target_magic_card_type = "";
        this.target_trap_card_type = "";
        this.target_card_text = "";
        this.target_scale = "";
        this.target_pendulum = "";
        this.target_link_marker = [];
        this.target_theme = "";
        this.target_rarity = "";
        this.target_card_evaluation = "";
        this.target_get_way_1 = [];
        this.target_get_way_2 = [];
        this.target_url = "";
        this.target_limit_type = "";
        this.target_last_update = "";
        this.target_last_upload = "";
        this.target_release_date = "";

        this.target_post_type = "insert";
      }

      this.showDialog = true;
    },

    //---------------------------
    // 更新
    //---------------------------
    saveItem() {
      if (this.target_id == "" || this.target_id == null) {
        alert("カードIDを入力してください");
        return;
      }

      if (this.target_name == "" || this.target_name == null) {
        alert("カード名を入力してください");
        return;
      }

      var msg = "";
      if (this.target_post_type == "insert") {
        msg = "新規登録";
      } else {
        msg = "更新";
      }
      if (!window.confirm("カードを" + msg + "します。よろしいですか？")) {
        return;
      }

      this.loading = true;

      var item = {
        id: Number(this.target_id),
        name: this.target_name,
        name_kana: this.target_name_kana,
        name_eng: this.target_name_eng,
        attr: this.target_attr,
        race: this.target_race,
        level: this.target_level,
        offensive: this.target_offensive,
        defensive: this.target_defensive,
        monster_type_1: this.target_monster_type_1,
        monster_type_2: this.target_monster_type_2,
        monster_type_3: this.target_monster_type_3,
        magic_card_type: this.target_magic_card_type,
        trap_card_type: this.target_trap_card_type,
        card_text: this.target_card_text,
        scale: this.target_scale,
        pendulum: this.target_pendulum,
        link_marker: this.target_link_marker.join("&"),
        theme: this.target_theme,
        rarity: this.target_rarity,
        card_evaluation: this.target_card_evaluation,
        get_way_1: this.target_get_way_1.join("&"),
        get_way_2: this.target_get_way_2.join("&"),
        url: this.target_url,
        limit_type: this.target_limit_type,
        last_update: this.target_last_update,
        last_upload: this.target_last_upload,
        release_date: this.target_release_date,
        post_type: this.target_post_type
      };
      console.log(item);

      axios
        .post(process.env.VUE_APP_MD_CARD_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          this.cardFilePut();
          this.getCardList();
          alert("更新しました！");
          this.showDialog = false;
        })
        .catch(error => {
          alert("カードの更新に失敗しました\n" + error);
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // カード削除
    //---------------------------
    delItem() {
      if (
        !window.confirm(
          "カード《" + this.target_name + "》を削除します。よろしいですか？"
        )
      ) {
        return;
      }

      var item = {
        id: Number(this.target_id)
      };
      //   console.log(item);

      axios
        .post(process.env.VUE_APP_CD_CARD_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("削除しました！");
          this.showDialog = false;
          this.getCardList();
        })
        .catch(error => {
          alert("テキストボックスに空か空白が設定されています\n" + error);
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.showDialog2 = false;
    },

    //---------------------------
    // jsonファイル出力(更新されたカードのjson)
    //---------------------------
    cardFilePut() {
      // this.loading = true;

      var url = location.hostname;

      axios

        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/yugiho_card_json_upload?url=" +
            url +
            "&id=" +
            this.target_id
        )

        .then(response => {
          console.log(response);
          // alert("更新しました！");
        })
        .catch(error => {
          console.log(error);
          // alert("予期せぬエラーが発生しました。\n" + error);
        })
        .finally(() => {
          // this.loading = false;
        });
    },

    //---------------------------
    // jsonファイル出力(更新されたカードのjson)
    //---------------------------
    cardIdFilePut() {
      if (!window.confirm("カードデータを本番反映します。よろしいですか？")) {
        return;
      }

      this.loading = true;

      var url = location.hostname;

      axios
        .get(
          "https://tool-test.matomeroyal.com/wp-json/appmedia/v1/yugiho_card_id_json_upload?url=" +
            url
        )

        .then(response => {
          console.log(response);
          alert("更新しました！");
        })
        .catch(error => {
          console.log(error);
          alert("予期せぬエラーが発生しました。\n" + error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // クリップボードにURL等をコピー
    //---------------------------
    copyToClipboard(item, type) {
      var text = "";
      if (type == "img") {
        text =
          "<a href='https://admin.appmedia.jp/master_duel/" +
          item.url +
          "'><img class='aligncenter' src='https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/" +
          item.id +
          ".webp' alt='" +
          item.name +
          "' width='60' loading='lazy'>" +
          "</a>";
      } else {
        text =
          "《<a href='https://admin.appmedia.jp/master_duel/" +
          item.url +
          "'>" +
          item.name +
          "</a>》";
      }

      var copyTextarea = document.createElement("textarea");
      copyTextarea.style.position = "fixed";
      copyTextarea.style.opacity = "0";
      copyTextarea.textContent = text;

      document.body.appendChild(copyTextarea);
      copyTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyTextarea);
    },

    //---------------------------
    // ダイアログ閉じ
    //---------------------------
    closeDialog() {
      this.showDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    }
  },

  watch: {},

  beforeCreate: function() {}
};
</script>

<style>
.deck_list {
  display: flex;
  flex-wrap: wrap;
}
.deck_list li {
  display: inline-block;
  width: 12%;
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
  margin-top: 2px;
}
.v-application .mt-2 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 10px;
  font-weight: bold;
  margin-top: 3px !important;
}
.limit {
  border: 2px solid #ff0000;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  background-color: #222;
  color: #ffff00;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  font-size: 11px;
  margin-right: 2px;
  position: absolute;
  top: 0px;
  left: 0px;
}
/* .v-btn {
  justify-content: left !important;
} */
</style>
